import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../common/api/config";
import Button from "../../common/components/Button";
import PageHeader from "../../common/components/PageHeader";
import { UserAvatar } from "../../common/components/UserAvatar";
import { SPACING } from "../../common/constants/spacing";
import { getReports } from "../api/reports";

const Reports = () => {
  const { t } = useTranslation("reports");
  const [reports, setReports] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await getReports();
        setReports(response);
      } catch (error) {
        console.error("Error fetching reports:", error);
      }
    };

    fetchReports();
  }, []);

  return (
    <Box>
      <PageHeader title={t("title")} description={t("description")} />

      <Box sx={{ mb: 3 }}>
        <Button variant="contained" onClick={() => navigate("/reports/create")}>
          {t("requestNewReport")}
        </Button>
      </Box>

      <TableContainer sx={{ mt: SPACING.sm }}>
        <Table sx={{ minWidth: 650 }} aria-label="reports table">
          <TableHead>
            <TableRow>
              <TableCell>{t("table.filename")}</TableCell>
              <TableCell>{t("table.periodStart")}</TableCell>
              <TableCell>{t("table.periodEnd")}</TableCell>
              <TableCell>{t("table.requestedBy")}</TableCell>
              <TableCell>{t("table.createdAt")}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((report) => (
              <TableRow
                key={report.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {report.filename}
                </TableCell>
                <TableCell>{report.period_start}</TableCell>
                <TableCell>{report.period_end}</TableCell>
                <TableCell>
                  <UserAvatar
                    name={
                      report?.created_by?.username || t("table.unknownUser")
                    }
                    image={report?.created_by?.avatar}
                    size={32}
                    tooltip={report?.created_by?.username}
                  />
                </TableCell>
                <TableCell>
                  {formatDistanceToNow(new Date(report.created_at), {
                    addSuffix: true,
                  })}
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      window.location.href = apiUrl + report.file;
                    }}
                    download
                  >
                    {t("table.download")}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Reports;
